<template>
    <div class="form-container update-info-container">
        <div v-if="message == ''" class="form">
            <div class="inputs-container">
                <h2>Update Information</h2>
                <div class="warning">
                    <p>We pride ourselves in having the most accurate and up-to-date information in the industry.
                       If there is an issue with the address, phone number, or any other information in this listing,
                       let us know and we will fix it right away.
                    </p>
                </div>

                <div class="form-fields">
                    <template v-if="!isAuthenticated">
                        <div :class="{ error: v$.name.$errors.length }">
                            <label>Name</label>
                            <input v-model="state.name" placeholder="Name" @blur="v$.name.$touch" />
                            <div class="input-errors" v-for="error of v$.name.$errors" :key="error.$uid">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div :class="{ error: v$.name.$errors.length }">
                            <label class="input-label">Email</label>
                            <input v-model="state.email" placeholder="Email" @blur="v$.email.$touch" />
                            <div class="input-errors" v-for="error of v$.email.$errors" :key="error.$uid">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                        <div :class="{ error: v$.name.$errors.length }">
                            <label class="input-label">Phone</label>
                            <input v-model="state.phone" placeholder="Phone" @blur="v$.phone.$touch" />
                            <div class="input-errors" v-for="error of v$.phone.$errors" :key="error.$uid">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </template>
                    <div :class="{ error: v$.comment.$errors.length }">
                        <label class="input-label">Update information</label>
                        <textarea v-model="state.comment" @blur="v$.comment.$touch"></textarea>
                        <div class="input-errors" v-for="error of v$.comment.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-buttons">
                <button class="cancel-btn" @click="closeForm">Cancel</button>
                <button class="forward-btn" @click="submit">Submit Report</button>
            </div>
        </div>
        <div class="info-message" v-else>
            <div class="message">
                <p>{{ message }}</p>
            </div>
            <div class="xmark">
                <fa-icon :icon="['fas', 'xmark']" aria-hidden="true" @click="closeForm"></fa-icon>
            </div>
        </div>
    </div>
</template>

<script>import script from './ListingUpdateInfo';
    export default script;</script>

<style lang="less" scoped>
    @import "./ListingUpdateInfo.less";
</style>
